function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { boxShadow } from "../../ThemeProvider/cssFor";
var buildStyle = function(param) {
    var _depth = param.depth, soft = _depth.boxShadow.soft;
    return {
        outerContainer: {
            base: {
                position: 'relative',
                display: 'flex',
                flexDirection: 'column',
                flexWrap: 'nowrap',
                maxHeight: 'inherit',
                maxWidth: 'inherit',
                height: '100%',
                width: '100%',
                overflow: 'hidden',
                boxSizing: 'border-box'
            }
        },
        header: {
            base: {
                flexGrow: 0,
                flexShrink: 0,
                overflow: 'visible',
                transition: 'box-shadow .2s ease-in-out'
            },
            shadow: {
                boxShadow: boxShadow(soft),
                zIndex: 1
            }
        },
        footer: {
            base: {
                flexGrow: 0,
                flexShrink: 0,
                overflow: 'visible',
                transition: 'box-shadow .2s ease-in-out'
            },
            shadow: {
                boxShadow: boxShadow(_objectSpread({}, soft, {
                    yOffset: "calc(".concat(soft.yOffset, " * -1)")
                })),
                zIndex: 1
            }
        },
        scrollView: {
            base: {
                flexGrow: 1,
                flexShrink: 1,
                maxWidth: '100vw',
                maxHeight: '100vh',
                height: '100%',
                width: '100%',
                overflowY: 'auto',
                position: 'relative'
            }
        }
    };
};
export default buildStyle;
